import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'piqet-angular-grid-equivalancy-image',
  templateUrl: './grid-equivalancy-image.component.html',
  styleUrls: ['./grid-equivalancy-image.component.css'],
})
export class GridEquivalancyImageComponent {
  icons: any;
  agInit(params: ICellRendererParams<any, any>): void {
    this.icons = params.value;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }
}
